import httpService from "./httpService";
import ServiceProvider from "../models/serviceProvider";
import ServiceTrade from "../models/serviceTrade";
import ServiceArea from "../models/serviceArea";

const apiEndpoint = "/serviceProviders";

const getServiceProviders = (idSubscription: number) => {
  return httpService.get<ServiceProvider[]>(
    `${apiEndpoint}/getServiceProviders?idSubscription=${idSubscription}`
  );
};

const getServiceProviderById = (idServiceProvider: number) => {
  return httpService.get<ServiceProvider>(
    `${apiEndpoint}/getServiceProviderById?idServiceProvider=${idServiceProvider}`
  );
};

const createServiceProvider = (
  idSubscription: number,
  account: ServiceProvider
) => {
  return httpService.post<ServiceProvider>(
    `${apiEndpoint}/createServiceProvider?idSubscription=${idSubscription}`,
    account
  );
};

const updateServiceProvider = (serviceProvider: ServiceProvider) => {
  return httpService.post<ServiceProvider>(
    `${apiEndpoint}/updateServiceProvider`,
    serviceProvider
  );
};

const deleteServiceProvider = (serviceProvider: ServiceProvider) => {
  return httpService.delete<ServiceProvider>(
    `${apiEndpoint}/deleteServiceProvider`,
    {
      data: serviceProvider,
    }
  );
};

const updateListOfServiceTrades = (
  idServiceProvider: number,
  serviceTrades: ServiceTrade[]
) => {
  return httpService.post<ServiceProvider>(
    `${apiEndpoint}/updateListOfServiceTrades`,
    {
      idServiceProvider,
      serviceTrades,
    }
  );
};

const updateListOfServiceAreas = (
  idServiceProvider: number,
  serviceAreas: ServiceArea[]
) => {
  return httpService.post<ServiceProvider>(
    `${apiEndpoint}/updateListOfServiceAreas`,
    {
      idServiceProvider,
      serviceAreas: serviceAreas,
    }
  );
};

const serviceProviderService = {
  getServiceProviders,
  getServiceProviderById,
  createServiceProvider,
  updateServiceProvider,
  deleteServiceProvider,
  updateListOfServiceTrades,
  updateListOfServiceAreas,
};

export default serviceProviderService;
